import angular from 'angular';

import DirectiveModule from './directive';
import EventAddModalComponent from './event-edit-modal.cmpt';

export default angular
    .module('application.component.modals.component.event-edit-modal', [
        DirectiveModule.name
    ])
    .component(EventAddModalComponent.selector, EventAddModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-edit-modal/index.js